import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { OmnidashboardErrors } from './omnidashboard-state.model';

const TIMEOUT_PHRASES = ['gateway timeout', 'request timeout', 'timeout'];

/** Extracts a human-readable message from heterogeneous HTTP/RxJS error shapes. */
export function getErrorMessage(err: unknown): string {
  if (!err || typeof err !== 'object') {
    return 'API request failed';
  }
  const e = err as Record<string, unknown>;
  const rawStatusText = e['statusText'];
  const rawMessage = e['message'];
  const statusText: string = typeof rawStatusText === 'string' ? rawStatusText : '';
  const message: string = typeof rawMessage === 'string' ? rawMessage : '';
  const nested = e['error'];
  let nestedST = '';
  if (nested && typeof nested === 'object') {
    const nestedStatusText = (nested as Record<string, unknown>)['statusText'];
    nestedST = typeof nestedStatusText === 'string' ? nestedStatusText : '';
  }
  if (statusText) {
    return statusText;
  }
  if (message) {
    return message;
  }
  if (nestedST) {
    return nestedST;
  }
  return 'Unknown error';
}

export function classifyApiError(error: unknown): OmnidashboardErrors {
  const errObj = (error && typeof error === 'object') ? error as Record<string, unknown> : null;
  const status = errObj && typeof errObj['status'] === 'number' ? errObj['status'] : null;
  const name = errObj && typeof errObj['name'] === 'string' ? errObj['name'] : '';
  const msg = getErrorMessage(error);
  const lowered = msg.toLowerCase();
  const isTimeoutByStatus = status === 504 || status === 408;
  const isTimeoutByName = name === 'TimeoutError';
  const isTimeoutByMessage = TIMEOUT_PHRASES.some((p) => lowered.includes(p));
  // Legacy app constant: unknown/network failures are surfaced as the timeout banner.
  const isTimeout = isTimeoutByStatus || isTimeoutByName || isTimeoutByMessage || msg === ConstantValues.unknownError;
  if (isTimeout) {
    return { hasTimeoutError: true, hasApiError: false };
  }
  return { hasTimeoutError: false, hasApiError: true };
}
